<template>
  <button v-on="$listeners" class="pw-button" :class="internalClass">
    <span>
      <span class="pw-button-icon" v-if="icon">
        <i class="mdi" :class="'mdi-' + icon"></i>
      </span>
      <span v-if="$slots.default">
        <slot />
      </span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    icon: String,
    color: {
      type: String,
      default: 'primary',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalClass() {
      let className = `is-${this.color}`;
      if (!this.$slots.default) {
        className += ' pw-button-only-icon';
      }
      if (this.rounded) {
        className += ' pw-button-rounded';
      }
      return className;
    },
  },
};
</script>

<style lang="scss">
$main: #5186ff;

$primary: #6ae1c8;
$primary-hover: #6ed2bd;
$primary-selected: #51c6ae;
$primary-disabled: #97decf;

$secondary: #5b89f2;
$secondary-hover: #5d86e1;
$secondary-selected: #5079d8;
$secondary-disabled: #8cabf3;

$terciary: #707070;
$terciary-hover: #a7b1b8;
$terciary-selected: #a0a4a7;
$terciary-disabled: #c2c2c2;

$quaternary: #f2f5f8;
$quaternary-hover: #a7b1b8;
$quaternary-selected: #a0a4a7;
$quaternary-disabled: #c2c2c2;

$quinary: #f25555;
$quinary-hover: #e14f4f;
$quinary-selected: #e54040;
$quinary-disabled: #ec9696;

$success: #19bf95;
$success-hover: #19bf95;
$success-selected: #19bf95;
$success-disabled: #19bf95;

$color1: #9f9f9f;
$color2: #ffc848;
$color3: #6ae1c8;
$color4: #19bf95;
$color5: #5186ff;
$color6: #707070;
$color7: #f25555;

$list: 'primary', 'secondary', 'terciary', 'quinary', 'success', 'color1', 'color2', 'color3',
  'color4', 'color5', 'color6', 'color7';

$colors: (
  primary: $primary,
  secondary: $secondary,
  terciary: $terciary,
  quinary: $quinary,
  success: $success,
  color1: $color1,
  color2: $color2,
  color3: $color3,
  color4: $color4,
  color5: $color5,
  color6: $color6,
  color7: $color7,
);

$colors-hover: (
  primary: $primary-hover,
  secondary: $secondary-hover,
  terciary: $terciary-hover,
  quinary: $quinary-hover,
  success: $success-hover,
  color1: $color1,
  color2: $color2,
  color3: $color3,
  color4: $color4,
  color5: $color5,
  color6: $color6,
  color7: $color7,
);

$colors-selected: (
  primary: $primary-selected,
  secondary: $secondary-selected,
  terciary: $terciary-selected,
  quinary: $quinary-selected,
  success: $success-selected,
  color1: $color1,
  color2: $color2,
  color3: $color3,
  color4: $color4,
  color5: $color5,
  color6: $color6,
  color7: $color7,
);

$colors-disabled: (
  primary: $primary-disabled,
  secondary: $secondary-disabled,
  terciary: $terciary-disabled,
  quinary: $quinary-disabled,
  success: $success-disabled,
  color1: $color1,
  color2: $color2,
  color3: $color3,
  color4: $color4,
  color5: $color5,
  color6: $color6,
  color7: $color7,
);

@mixin variantColors($outlined: false) {
  @each $var in $list {
    @if $outlined {
      &.is-#{$var}-outlined {
        border-color: map-get($colors, $var);
        color: map-get($colors, $var);
        background-color: transparent;
        &:hover {
          border-color: map-get($colors-hover, $var);
        }
        &:focus,
        &:active {
          border-color: map-get($colors-selected, $var);
        }
      }
    }
    &.is-#{$var} {
      background-color: map-get($colors, $var);
      border-color: map-get($colors, $var);
      color: white;
      &:hover {
        background-color: map-get($colors-hover, $var);
      }
      &:focus,
      &:active {
        background-color: map-get($colors-selected, $var);
      }
      &:disabled {
        background-color: map-get($colors-disabled, $var);
      }
    }
  }
}
.pw-button {
  & + .pw-button {
    margin-left: 8px;
  }
  &.is-transparent {
    background-color: transparent;
  }
  &-rounded {
    border-radius: 25px;
  }
  padding: 0.375rem 0.75rem;
  border-radius: 3px;
  border: 1px solid transparent;
  height: 100%;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 500;
  font-family: 'Roboto', sans-serif;
  cursor: pointer;
  outline: none;
  @include variantColors(true);
  &.pw-button-only-icon {
    width: 35.78px;
    height: 35.78px;
    position: relative;
    overflow: hidden;
    & > span {
      display: flex;
      justify-content: center;
      align-items: center;
      vertical-align: inherit;
    }
  }
  .pw-button-icon {
    & + span {
      //margin-left: .5rem;
    }
    vertical-align: middle;
    i.mdi {
      font-size: 1.25rem;
      line-height: 0.75rem;
    }
  }
}
</style>
